/**
 * supplierManagementApi.js
 * API helpers for Supplier admin endpoints (Sitting 8 Phase 2A backend:
 * get_suppliers + manage_supplier).
 */

import { apiFetch } from '../../auth/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071/api';

/**
 * GET /get_suppliers
 * Returns the suppliers array (unwrapped from the {"suppliers": [...]} envelope).
 */
export async function getSuppliers(callerEmail) {
  const params = new URLSearchParams({ caller_email: callerEmail });
  const res = await apiFetch(`${API_BASE_URL}/get_suppliers?${params}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API error: ${res.status}`);
  }
  const data = await res.json();
  return data.suppliers || [];
}

/**
 * POST /manage_supplier
 * payload: { supplier_name, duns? }  — omit duns key when empty.
 * Returns the newly created Supplier doc.
 */
export async function createSupplier(callerEmail, payload) {
  const params = new URLSearchParams({ caller_email: callerEmail });
  const res = await apiFetch(`${API_BASE_URL}/manage_supplier?${params}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json();
}
